// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInterestTemplateIdPropertyDto
 */
export interface IInterestTemplateIdPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IInterestTemplateIdPropertyDto
     */
    interest_template_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IInterestTemplateIdPropertyDto
     */
    interest_template_id_state_id?: IInterestTemplateIdPropertyDtoInterestTemplateIdStateIdEnum;
}

/**
* @export
* @enum {string}
*/
export enum IInterestTemplateIdPropertyDtoInterestTemplateIdStateIdEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IInterestTemplateIdPropertyDto interface.
 */
export function instanceOfIInterestTemplateIdPropertyDto(value: object): value is IInterestTemplateIdPropertyDto {
    return true;
}

export function IInterestTemplateIdPropertyDtoFromJSON(json: any): IInterestTemplateIdPropertyDto {
    return IInterestTemplateIdPropertyDtoFromJSONTyped(json, false);
}

export function IInterestTemplateIdPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInterestTemplateIdPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'interest_template_id': json['interest_template_id'] == null ? undefined : json['interest_template_id'],
        'interest_template_id_state_id': json['interest_template_id_state_id'] == null ? undefined : json['interest_template_id_state_id'],
    };
}

export function IInterestTemplateIdPropertyDtoToJSON(json: any): IInterestTemplateIdPropertyDto {
    return IInterestTemplateIdPropertyDtoToJSONTyped(json, false);
}

export function IInterestTemplateIdPropertyDtoToJSONTyped(value?: IInterestTemplateIdPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'interest_template_id': value['interest_template_id'],
        'interest_template_id_state_id': value['interest_template_id_state_id'],
    };
}

